
/* 
Composite control that binds 2 controls which enables the functionality to select a currency
from the drop down and format numbers based on user's my account preference 

Usage: <div currency-masking  currency-data-url="/jhire/field...."
        currency-data-response-key="resultList"></div>
 
Description: Easy to plug and play to any jsp page 

Dependencies: jv.ajaxSelect.js, jv.numberFormat.mask.directive.js 
 */

angular.module('jv.common.currency.directive', [
        'jv.Common.AjaxSelect', 
        'jv.common.numberFormatter.directive'
    ])

    .value('currencyConfig', {
        controlIdPrefix: 'currencyCustom'
    })

    .factory('JsonToHtmlPropertyFAC', [function(){
        return function(json){
            var template = '';
            for(var key in json){
                template += key + ' ';
                if(json[key]){
                    template += '= ' + json[key];
                }
            }
            return template;
        };
    }])

    .factory('currencyAjaxSelectTagFAC', ['JsonToHtmlPropertyFAC', function(JsonToHtmlPropertyFAC){
        return function(url, key){
            var config = {
                'jv-ajax-select': '',
                'jv-ajax-select-id': '"currencyCode"',
                'jv-ajax-select-no-pagination': '"false"',
                'jv-ajax-select-url': '"{0}"',
                'jv-ajax-select-response-key': '"{1}"',
                'jv-ajax-select-text': '"displayName"',
                'jv-ajax-selected-text': '"codeWithSymbol"',
                'jv-ajax-select-query-param-name': '"q"',
                'jv-ajax-select-placeholder': '"——"',
                'jv-ajax-select-can-clear': '"true"',
                'jv-ajax-select-dropdown-class': '"currency-control-container"',
                'jv-ajax-select-populate': '',
                'ng-model': '"currencyCode"'
            };
            return '<div {0}></div>'.format(JsonToHtmlPropertyFAC(config).format(url, key));
        };
    }])

    .factory('currencyValueFormatterTagFAC', [function(){
        return function(currencyDataIsReadonly){
            return '<div class="currency-control-input">' +
                    '<input ng-disabled="{0}" number-formatter="{ addNumberFormatMasking: true}" ng-model="numberFormatter"/>'.format(currencyDataIsReadonly) +
                '</div>';
        };
    }])

    .factory('currencyNgModelTagFAC', [function(){
        return function(controlId){
            return '<input type="text" id="{0}" style="display: none;" jvfieldtype="Currency" />'.format(controlId);
        };
    }])

    .factory('currencyTemplateFAC', ['currencyAjaxSelectTagFAC', 'currencyValueFormatterTagFAC', 'currencyNgModelTagFAC',
        function(currencyAjaxSelectTagFAC, currencyValueFormatterTagFAC, currencyNgModelTagFAC){
            return function(id, controlId, url, key, styleTag, className, currencyDataIsReadonly){
                return '<div {5} class="{4}" style="{3}">{0}{1}{2}</div>'.format(
                            controlId ? currencyNgModelTagFAC(controlId) : '',
                            currencyAjaxSelectTagFAC(url, key), 
                            currencyValueFormatterTagFAC(currencyDataIsReadonly),
                            styleTag ? styleTag : '',
                            className ? className : 'currency-control',
                            id ? ('id="{0}"'.format(id)) : ''
                        );
            };
    }])

    .directive('currencyMasking', ['$compile','$timeout', 'currencyTemplateFAC', 'currencyConfig',
        function($compile, $timeout, currencyTemplateFAC, currencyConfig) {
            return {
                restrict: 'AE',
                require: 'ngModel',
                scope: {
                    currencyDataUrl: '@',
                    currencyDataResponseKey: '@',
                    currencyDataMap: '=',
                    currencyValue: '@',
                    currencyUnit: '@',
                    currencyIgnoreControlIdPrefix:'@'
                },
                link: function($scope, elem, attrs, ngModel) {
                    var controlId = '';
                    if(angular.isDefined(attrs.currencyControlId)) {
                        var customPrefix = angular.isDefined(attrs.currencyIgnoreControlIdPrefix) ? '' : currencyConfig.controlIdPrefix;
                        controlId = customPrefix + attrs.currencyControlId;
                    }
                    var currencyDataIsReadonly = angular.isDefined(attrs.readonly) ? true : false;
                    var _currencyControlsTemplate = $(currencyTemplateFAC(attrs.id, controlId, attrs.currencyDataUrl, attrs.currencyDataResponseKey, attrs.style, attrs.class, currencyDataIsReadonly));

                    //updates value in hidden textbox for non angular POST back calls
                    var updateValue = function(value){
                        if(attrs.currencyControlId){
                            $('#'+ controlId).val(JSON.stringify(value));
                        }

                        // Timer function is used to trigger another digest cycle to render model content, which is raised after default cycle destroyed.
                        $timeout(function(){
                            $scope.$apply();
                        });
                    };

                    var addClassOnFocus = function(selectedClass) {
                        $(this).addClass(selectedClass);
                        $(this).parent().parent().first().find("a").addClass(selectedClass);
                    };

                    var removeClassOnBlur = function(selectedClass) {
                        $(this).removeClass(selectedClass);
                        $(this).parent().parent().first().find("a").removeClass(selectedClass);
                    };

                    //method to set focus on control
                    var bindOnFocusClass = function(selectedClass){
                        var inputCurrencyText = _currencyControlsTemplate.find('div.currency-control-input input');
                        if(inputCurrencyText){
                            if (parseFloat(jQuery.fn.jquery) > 1.3) {
                                inputCurrencyText.on("focus", addClassOnFocus(selectedClass));
                                inputCurrencyText.on("blur", removeClassOnBlur(selectedClass));
                            } else {
                                inputCurrencyText.bind("focus", addClassOnFocus(selectedClass));
                                inputCurrencyText.bind("blur", removeClassOnBlur(selectedClass));
                            }
                        }
                    };

                    //if control need not to be focussed, pass this property
                    if(angular.isUndefined(attrs.currencyNoFocus)){
                        bindOnFocusClass('activate');
                    }
                    elem.replaceWith($compile(_currencyControlsTemplate)($scope));

                    ngModel.$render = function(){
                        var newVal = this.$viewValue;
                        if(angular.isUndefined(newVal) && attrs.currencyValue && attrs.currencyUnit){
                            //this will be called when angular model is not initialized and value is passed as directive's property
                            newVal = {
                                value: attrs.currencyValue,
                                currencyCode: attrs.currencyUnit
                            };
                            ngModel.$setViewValue(newVal);

                        }
                        if(angular.isObject(newVal)){
                            $scope.numberFormatter = newVal.value;
                            var currencyKey = newVal.currencyCode;
                            if($scope.currencyDataMap && $scope.currencyDataMap[currencyKey]){
                                $scope.currencyCode = {
                                    codeWithSymbol: $scope.currencyDataMap[currencyKey].codeWithSymbol,
                                    currencyCode: $scope.currencyDataMap[currencyKey].currencySymbol
                                };
                            }
                            updateValue(newVal);
                        }
                    };

                    $scope.$watch('currencyCode', function(newVal, oldVal) {
                        if (oldVal === newVal) {
                            return;
                        }

                        if(angular.isString(newVal)){
                            if (ngModel.$viewValue) {
                                var k = ngModel.$viewValue;
                                k.currencyCode = newVal;
                                ngModel.$setViewValue(k);
                            } else {
                                ngModel.$setViewValue({
                                    currencyCode: newVal
                                });
                            }
                            updateValue(ngModel.$viewValue);
                        }
                    });

                    $scope.$watch('numberFormatter', function(newVal, oldVal) {
                        if (oldVal === newVal){
                            return;
                        }

                        if (ngModel.$viewValue) {
                            var j = ngModel.$viewValue;
                            j.value = newVal;
                            ngModel.$setViewValue(j);
                        } else {
                            ngModel.$setViewValue({
                                numberFormatter: newVal
                            });
                        }
                        updateValue(ngModel.$viewValue);
                    });
                }
            };
        }
]);
